/**
 * MA シーケンスファイル（CSV / RPP）の判定と、アップロード時の
 * バリエーション名ルール。
 *
 * ショット編集モーダル / 新規提出モーダル / useMaSequence で共用する。
 */

/** MA シーケンスファイル（CSV / RPP）名かどうか */
export function isMaSequenceFileName(fileName: string): boolean {
  return /\.(csv|rpp)$/i.test(fileName);
}

/** Reaper プロジェクトファイル（.rpp）名かどうか（パーサ分岐用） */
export function isRppFileName(fileName: string): boolean {
  return /\.rpp$/i.test(fileName);
}

/**
 * アップロードファイル名から variation_name を決める。
 *
 * MA シーケンスファイル（.csv / .rpp）でステムにセマンティックバージョニング
 * （`_v1.1.0` 等）を含む場合は `_v` の手前までをバリエーション名にする
 * （例: `250_TFAF_風車ランプ演出_v1.1.0_moriyama.RPP` → `250_TFAF_風車ランプ演出`）。
 * 同ベース名の別バージョンが自動で同一テイク履歴に積まれる。
 * 通常のメディアファイルは従来どおり拡張子を除いたステムをそのまま使う。
 */
export function variationNameForUpload(fileName: string): string {
  const stem = fileName.replace(/\.[^/.]+$/, '');
  if (isMaSequenceFileName(fileName)) {
    const versioned = stem.match(/^(.+)_v\d+(\.\d+)*.*$/i);
    if (versioned) return versioned[1];
  }
  return stem;
}
